import React from 'react'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MessageIcon from '@mui/icons-material/Message';

export default function ContactUs() {
  return (
    <div>
      <section className='contacts'>
        <div className='container'>
          <div className="row">
            <div className="col-12">
              <div className="contacts-heading">
                <div className="contacts-hone">
                  <h1>ContactUs</h1>
                </div>
                <div className="heads-point">
                  <ul>
                    <li><Link to='#'>Home</Link></li>
                    <li><ArrowForwardIosIcon /></li>
                    <li>Contact</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='contacts-two'>
        <div className="container">
          <div className="row">
           <div className="col-12">
           <div className="contacts-forms">
              <div className="contacts-heading">
                <h5>Start your new project</h5>
                <h2>Looking for an excellent idea?</h2>
              </div>
              <form className='cont-forms'>
                <div className="contacts-form-in">
                  <input type="text" className='formcont' placeholder='Your Name' />
                  <TagFacesIcon />
                </div>
                <div className="contacts-form-in">
                  <input type="text" className='formcont' placeholder='Your Email Address' />
                  <EmailIcon />
                </div>
                <div className="contacts-form-in">
                  <input type="number" className='formcont' placeholder='Your Phone' />
                  <LocalPhoneIcon />
                </div>
                <div className="contacts-form-in">
                  <textarea rows={4} cols={40} className='formcont'   placeholder='Your Message' />
                  <MessageIcon />
                </div>
              </form>
              <div className="contact-btn">
                <Link to="#">SEND MESSAGE</Link> 
              </div>
            </div>
           </div>
          </div>
        </div>
      </section>
    </div>
  )
}